import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'
import login from '../views/login/index.vue'
import { consumeHashToken, getAccessToken } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/index"
  },

  {
    path: '/index',
    name: 'index',
    component: index
  },

  {
    path: '/login',
    name: 'login',
    component: login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 大屏需登录：PC 菜单跳转经 hash 带入令牌；直接访问且未登录则进登录页
router.beforeEach((to, from, next) => {
  consumeHashToken()
  if (to.path === '/login' || getAccessToken()) {
    next()
    return
  }
  next({ path: '/login', query: { redirect: to.fullPath } })
})

export default router
